<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">

      <!-- Header -->
      <div class="panel-header">
        <h2 class="titulo">Panel de Aliados</h2>
        <div class="panel-header-acciones">
          <div v-if="hotelSeleccionado" class="switch-tipo-paciente">
            <button :class="{ active: tipoPacienteVista === 'huesped' }" @click="tipoPacienteVista = 'huesped'">Huéspedes</button>
            <button :class="{ active: tipoPacienteVista === 'colaborador' }" @click="tipoPacienteVista = 'colaborador'">Colaboradores</button>
          </div>
          <select v-if="!esHotelUsuario" v-model="hotelSeleccionado" class="form-select selector-hotel">
            <option value="">— Seleccionar aliado —</option>
            <option v-for="h in hoteles" :key="h.id" :value="h.nombre">{{ h.nombre }}</option>
          </select>
        </div>
      </div>

      <!-- Estado de carga -->
      <div v-if="cargando" class="estado-cargando">
        <div class="spinner"></div>
        <p>Cargando información del panel...</p>
      </div>

      <!-- Estado vacío -->
      <div v-else-if="!hotelSeleccionado" class="estado-vacio">
        <span class="material-icons estado-icon">business</span>
        <p>Selecciona un aliado para ver su panel de operaciones</p>
      </div>

      <template v-else>

        <!-- KPIs -->
        <div class="kpi-grid">
          <div class="kpi-card" style="--kpi-color: var(--brand-primary)">
            <span class="material-icons kpi-icon">assignment</span>
            <div class="kpi-data">
              <span class="kpi-num">{{ kpis.total }}</span>
              <span class="kpi-lbl">Total consultas</span>
            </div>
          </div>
          <div class="kpi-card" style="--kpi-color: var(--brand-accent-sage)">
            <span class="material-icons kpi-icon">people</span>
            <div class="kpi-data">
              <span class="kpi-num">{{ kpis.unicos }}</span>
              <span class="kpi-lbl">Pacientes únicos</span>
            </div>
          </div>
          <div class="kpi-card" style="--kpi-color: #305065">
            <span class="material-icons kpi-icon">public</span>
            <div class="kpi-data">
              <span class="kpi-num kpi-num-sm">{{ kpis.pais }}</span>
              <span class="kpi-lbl">País más frecuente</span>
            </div>
          </div>
        </div>

        <!-- Las 3 gráficas en una sola fila -->
        <div class="graficos-fila">
          <div class="grafico-card grafico-tercio">
            <h4 class="grafico-titulo">Consultas por mes</h4>
            <div class="grafico-wrap">
              <Bar :data="chartMeses" :options="optsBar" />
            </div>
          </div>
          <div class="grafico-card grafico-tercio">
            <h4 class="grafico-titulo">Distribución por género</h4>
            <div class="grafico-wrap">
              <Doughnut :data="chartGenero" :options="optsDoughnut" />
            </div>
          </div>
          <div class="grafico-card grafico-tercio">
            <h4 class="grafico-titulo">Pacientes por país</h4>
            <div class="grafico-wrap">
              <Doughnut :data="chartPaises" :options="optsDoughnut" />
            </div>
          </div>
        </div>

        <!-- Distribución por idioma -->
        <div class="graficos-fila">
          <div class="grafico-card grafico-tercio">
            <h4 class="grafico-titulo">Distribución por idioma</h4>
            <div class="grafico-wrap">
              <Doughnut :data="chartIdioma" :options="optsDoughnut" />
            </div>
          </div>
        </div>

        <!-- Analíticas de encuesta de satisfacción -->
        <div class="graficos-fila" v-if="encuestasHotel.length">
          <div class="grafico-card" style="flex:1">
            <h4 class="grafico-titulo">Encuestas de satisfacción</h4>
            <div class="encuesta-metricas">
              <div class="encuesta-kpi">
                <span class="encuesta-kpi-num">{{ encuestaMetricas.total }}</span>
                <span class="encuesta-kpi-lbl">Respuestas totales</span>
              </div>
              <div class="encuesta-kpi">
                <span class="encuesta-kpi-num">{{ encuestaMetricas.recomendacion }}</span>
                <span class="encuesta-kpi-lbl">Recomendación prom. (1–5)</span>
              </div>
              <div class="encuesta-kpi" v-for="p in encuestaMetricas.promedios" :key="p.campo">
                <span class="encuesta-kpi-num">{{ p.promedio }}</span>
                <span class="encuesta-kpi-lbl">{{ p.etiqueta }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla historial -->
        <div class="tabla-card">
          <div class="tabla-card-header">
            <h4>Historial de consultas</h4>
            <input
              v-model="busqueda"
              class="form-control input-buscar"
              placeholder="Buscar por nombre, diagnóstico…"
            >
          </div>
          <div class="tabla-scroll">
            <table class="tabla">
              <thead>
                <tr>
                  <!-- Se quitó la columna "Folio" -->
                  <th>Fecha</th>
                  <th>Paciente</th>
                  <th>Edad</th>
                  <th>Género</th>
                  <th>País</th>
                  <th>Idioma</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!consultasFiltradas.length">
                  <td colspan="6" class="td-vacio">Sin resultados.</td>
                </tr>
                <tr v-for="c in consultasFiltradas" :key="c.folio">
                  <!-- Se quitó la celda de Folio -->
                  <td>{{ fmtFecha(c.fecha) }}</td>
                  <td>{{ c.nombre }} {{ c.apellido_paterno }}</td>
                  <td>{{ c.edad }} a.</td>
                  <td>{{ c.genero }}</td>
                  <td>{{ c.pais }}</td>
                  <td>{{ c.idioma || 'N/A' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  Title, Tooltip, Legend, ArcElement,
} from 'chart.js';
import { Bar, Doughnut } from 'vue-chartjs';
import SlideBar from '@/components/SlideBar.vue';
import { getConsultas, getEncuestas, getHoteles } from '@/utils/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const PALETTE = ['#133E68', '#607f70', '#305065', '#8aab96', '#1b6ca8', '#4e9e6f', '#2b4054', '#a8c5a0'];
const MESES_ES = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function frecuente(arr) {
  if (!arr.length) return '—';
  const c = {};
  arr.forEach(v => { if (v) c[v] = (c[v] || 0) + 1; });
  return Object.entries(c).sort((a, b) => b[1] - a[1])[0]?.[0] || '—';
}

export default {
  name: 'PanelHotel',
  components: { SlideBar, Bar, Doughnut },
  data() {
    return {
      sidebarCerrado: false,
      cargando: true,
      hoteles: [],
      consultas: [],
      encuestas: [],
      hotelSeleccionado: '',
      esHotelUsuario: false,
      busqueda: '',
      tipoPacienteVista: 'huesped',
      optsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false } },
          y: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 } },
        },
      },
      optsDoughnut: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'bottom', labels: { font: { size: 12 }, boxWidth: 14, padding: 10 } },
        },
      },
    };
  },
  computed: {
    consultasHotel() {
      return this.consultas.filter(c =>
        c.nombre_hotel === this.hotelSeleccionado &&
        (c.tipo_paciente || 'huesped') === this.tipoPacienteVista &&
        !c.oculto
      );
    },
    consultasFiltradas() {
      if (!this.busqueda.trim()) return this.consultasHotel;
      const q = this.busqueda.toLowerCase();
      return this.consultasHotel.filter(c =>
        Object.values(c).some(v => v && v.toString().toLowerCase().includes(q))
      );
    },
    kpis() {
      const cs = this.consultasHotel;
      const unicos = new Set(cs.map(c => `${c.nombre}_${c.apellido_paterno}`)).size;
      return {
        total: cs.length,
        unicos,
        diagnostico: frecuente(cs.map(c => c.diagnostico)),
        pais: frecuente(cs.map(c => c.pais)),
      };
    },
    chartMeses() {
      const cs = this.consultasHotel;
      const withDate = cs.map(c => c.fecha?.substring(0, 7)).filter(Boolean);
      const ultimo = [...withDate].sort().pop() || `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
      const [uy, um] = ultimo.split('-').map(Number);
      const meses = [];
      for (let i = 5; i >= 0; i--) {
        let y = uy, m = um - i;
        while (m <= 0) { m += 12; y--; }
        meses.push(`${y}-${String(m).padStart(2, '0')}`);
      }
      return {
        labels: meses.map(k => { const [y, m] = k.split('-'); return `${MESES_ES[+m]} ${y}`; }),
        datasets: [{
          label: 'Consultas',
          data: meses.map(k => cs.filter(c => c.fecha?.startsWith(k)).length),
          backgroundColor: '#133E68',
          borderRadius: 6,
        }],
      };
    },
    chartGenero() {
      const cs = this.consultasHotel;
      const c = {};
      cs.forEach(x => { if (x.genero) c[x.genero] = (c[x.genero] || 0) + 1; });
      const labels = Object.keys(c);
      return { labels, datasets: [{ data: labels.map(l => c[l]), backgroundColor: PALETTE }] };
    },
    chartPaises() {
      const cs = this.consultasHotel;
      const c = {};
      cs.forEach(x => { if (x.pais) c[x.pais] = (c[x.pais] || 0) + 1; });
      const labels = Object.keys(c);
      return { labels, datasets: [{ data: labels.map(l => c[l]), backgroundColor: PALETTE }] };
    },
    chartIdioma() {
      const cs = this.consultasHotel;
      const c = {};
      cs.forEach(x => { if (x.idioma) c[x.idioma] = (c[x.idioma] || 0) + 1; });
      const labels = Object.keys(c);
      return { labels, datasets: [{ data: labels.map(l => c[l]), backgroundColor: PALETTE }] };
    },
    encuestasHotel() {
      const hotel = (this.hotelSeleccionado || '').trim().toLowerCase();
      return this.encuestas.filter(e => (e.hotel || '').trim().toLowerCase() === hotel);
    },
    encuestaMetricas() {
      const es = this.encuestasHotel;
      const promedio = (campo) => {
        const vals = es.map(e => Number(e[campo])).filter(v => v > 0);
        return vals.length ? (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(1) : '—';
      };
      const campos = [
        { campo: 'tiempo_espera', etiqueta: 'Tiempo de espera' },
        { campo: 'gafete', etiqueta: 'Uso de gafete' },
        { campo: 'presentacion', etiqueta: 'Presentación del médico' },
        { campo: 'atencion_medico', etiqueta: 'Atención médica' },
        { campo: 'claridad_explicacion', etiqueta: 'Claridad de explicación' },
        { campo: 'nivel_ingles', etiqueta: 'Nivel de inglés' },
        { campo: 'calidad_precio', etiqueta: 'Calidad-precio' },
        { campo: 'atencion_domedica', etiqueta: 'Atención Domédica' },
      ];
      return {
        total: es.length,
        recomendacion: promedio('recomendacion'),
        promedios: campos.map(c => ({ ...c, promedio: promedio(c.campo) })),
      };
    },
  },
  methods: {
    actualizarSidebar(estado) { this.sidebarCerrado = estado; },
    fmtFecha(f) {
      if (!f) return '—';
      const [y, m, d] = f.split('-');
      return `${d}/${m}/${y}`;
    },
    async cargarDatos() {
      this.cargando = true;
      try {
        const [hoteles, consultas, encuestas] = await Promise.all([getHoteles(), getConsultas(), getEncuestas()]);
        // Solo mostrar aliados activos en el selector del panel
        this.hoteles = (hoteles || []).filter(h => h.activo === true || h.activo === 1 || h.activo === '1');
        this.consultas = consultas || [];
        this.encuestas = encuestas || [];
        if (localStorage.getItem('tipo_sesion') === 'hotel') {
          this.esHotelUsuario = true;
          this.hotelSeleccionado = localStorage.getItem('hotel_nombre') || '';
        } else if (this.hotelSeleccionado && !this.hoteles.some(h => h.nombre === this.hotelSeleccionado)) {
          this.hotelSeleccionado = '';
        }
      } catch (err) {
        console.error('Error cargando datos del panel de aliados:', err);
      } finally {
        this.cargando = false;
      }
    },
  },
  mounted() { this.cargarDatos(); },
};
</script>

<style scoped>
/* ---------- LAYOUT ---------- */
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background: var(--brand-beige);
}

.contenido {
  flex-grow: 1;
  padding: 24px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido { margin-left: 80px; }

/* ---------- HEADER ---------- */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.titulo {
  font-size: 26px;
  font-weight: 700;
  color: var(--brand-primary);
  margin: 0;
}

.panel-header-acciones {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.switch-tipo-paciente {
  display: flex;
  border: 2px solid var(--brand-primary);
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
}

.switch-tipo-paciente button {
  padding: 9px 16px;
  border: none;
  background: var(--white);
  color: var(--brand-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}

.switch-tipo-paciente button.active {
  background: var(--brand-primary);
  color: var(--white);
}

.selector-hotel {
  width: 280px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 14px;
  color: var(--brand-secondary);
  background: var(--white);
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
}

.selector-hotel:focus { border-color: var(--brand-accent-sage); }

/* ---------- ESTADO VACÍO ---------- */
.estado-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
  color: var(--brand-secondary-light);
}

.estado-icon { font-size: 72px; opacity: 0.35; }

.estado-vacio p { font-size: 16px; font-weight: 500; margin: 0; }

/* ---------- KPI GRID ---------- */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.kpi-card {
  background: var(--white);
  border-radius: 14px;
  padding: 20px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.08);
  border-left: 4px solid var(--kpi-color, var(--brand-primary));
}

.kpi-icon {
  font-size: 32px;
  color: var(--kpi-color, var(--brand-primary));
  opacity: 0.85;
}

.kpi-data {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kpi-num {
  font-size: 28px;
  font-weight: 800;
  color: var(--brand-primary);
  line-height: 1;
}

.kpi-num-sm {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.kpi-lbl {
  font-size: 12px;
  color: var(--brand-secondary-light);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ---------- GRÁFICOS ---------- */
.graficos-fila {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.grafico-card {
  background: var(--white);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.08);
  margin-bottom: 16px;
}

.grafico-tercio { flex: 1; min-width: 0; max-width: 450px; }

.grafico-titulo {
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 700;
  color: var(--brand-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.grafico-wrap { position: relative; height: 260px; }

.encuesta-metricas {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.encuesta-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 14px 18px;
  background: var(--brand-beige);
  border-radius: 10px;
  min-width: 140px;
}

.encuesta-kpi-num {
  font-size: 22px;
  font-weight: 800;
  color: var(--brand-primary);
  line-height: 1;
}

.encuesta-kpi-lbl {
  font-size: 11px;
  color: var(--brand-secondary-light);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-top: 4px;
}

/* ---------- TABLA ---------- */
.tabla-card {
  background: var(--white);
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.08);
  overflow: hidden;
  margin-bottom: 24px;
}

.tabla-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(19, 62, 104, 0.08);
  gap: 12px;
  flex-wrap: wrap;
}

.tabla-card-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--brand-primary);
}

.input-buscar {
  width: 260px;
  padding: 8px 14px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
}

.input-buscar:focus { border-color: var(--brand-accent-sage); }

.tabla-scroll { overflow-x: auto; }

.tabla {
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
}

.tabla thead {
  background: var(--brand-primary);
  color: var(--white);
}

.tabla th {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
}

.tabla tbody tr {
  border-bottom: 1px solid rgba(19, 62, 104, 0.07);
  transition: background 0.15s;
}

.tabla tbody tr:last-child { border-bottom: none; }
.tabla tbody tr:hover { background: rgba(96, 127, 112, 0.06); }

.tabla td {
  padding: 11px 16px;
  font-size: 13px;
  color: var(--brand-secondary);
}

.td-folio { font-weight: 700; color: var(--brand-primary); }
.td-vacio { text-align: center; padding: 32px; color: var(--brand-secondary-light); }

/* ---------- ESTADO DE CARGA ---------- */
.estado-cargando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
  color: var(--brand-primary);
  font-weight: 600;
}

.spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(19, 62, 104, 0.12);
  border-top-color: var(--brand-accent-sage, #607f70);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 900px) {
  .kpi-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 1024px) {
  .contenido { margin-left: 80px; }
}

@media (max-width: 768px) {
  .graficos-fila { flex-direction: column; }
  .contenido { margin-left: 0 !important; padding: 12px; padding-top: 70px; }
  .panel-header { flex-direction: column; align-items: flex-start; }
  .panel-header-acciones { width: 100%; flex-direction: column; align-items: stretch; }
  .selector-hotel { width: 100%; }
  .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .input-buscar { width: 100%; }
}

@media (max-width: 480px) {
  .kpi-grid { grid-template-columns: 1fr; }
  .kpi-num { font-size: 22px; }
}
</style>
